export const findSimilarModalReducerKey = 'findSimilarModalReducerKey';
export const findSimilarModalSetIsLoadingReducerType = 'findSimilarModalSetIsLoadingReducerType';
export const findSimilarModalSetDataReducerType = 'findSimilarModalSetDataReducerType';
export const findSimilarModalSetCurrentDbReducerType = 'findSimilarModalSetCurrentDbReducerType';
export const findSimilarModalSetDatabasesOrderReducerType = 'findSimilarModalSetDatabasesOrderReducerType';
export const findSimilarModalSetAvailableDatabasesReducerType = 'findSimilarModalSetAvailableDatabasesReducerType';

export const typeOfFindSimilarModal = 'typeOfFindSimilarModal';
